// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__21zlX","insightsList":"newBusinessInsightsMenu_insightsList__1id4L","active":"newBusinessInsightsMenu_active__2R1JQ"};